export interface IPagesMap {
  name: string;
  href: string;
}

export const pagesMap: Array<IPagesMap> = [
  {
    name: 'Услуги',
    href: '/services'
  },
  {
    name: 'Учебный центр',
    href: '/training'
  },
  // {
  //   name: 'Вебинары',
  //   href: '/webinars'
  // },
  {
    name: 'О нас',
    href: '/about'
  },
  {
    name: 'Наша команда',
    href: '/team'
  },
  {
    name: 'Контакты',
    href: '/contacts'
  },
  {
    name: 'Вакансии',
    href: '/vacancy'
  },
  {
    name: 'Новости компании',
    href: '/news'
  },
  {
    name: 'Блог о закупках',
    href: '/blog'
  },
  {
    name: 'Пользовательское соглашение',
    href: '/legal'
  },
  {
    name: 'Политика конфиденциальности',
    href: '/privacy'
  },
  {
    name: 'Уведомление об использовании файлов cookie',
    href: '/cookies'
  },
  {
    name: 'Согласие на информационную и рекламную рассылку',
    href: '/newsletter'
  },
];
